<template>
  <b-row>
    <b-col cols="5">
      <validation-observer v-slot="{ invalid }">
        <form @submit.prevent="submitProfileData">
          <b-card title="Profile Info">
            <b-row>
              <b-col cols="6">
                <validation-provider name="First Name" v-slot="context">
                  <b-form-group label="First Name">
                    <b-form-input
                      placeholder="e.g Brynhild"
                      v-model="user.first_name"
                      :state="getValidationState(context)"
                      :disabled="updateIsDisabled"
                      v-bind="context.ariaInput"
                    />

                    <b-form-invalid-feedback v-bind="context.ariaMsg">
                      {{ context.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="6">
                <validation-provider name="Last Name" v-slot="context">
                  <b-form-group label="Last Name">
                    <b-form-input
                      placeholder="e.g Borgen"
                      v-model="user.last_name"
                      :state="getValidationState(context)"
                      :disabled="updateIsDisabled"
                      v-bind="context.ariaInput"
                    />

                    <b-form-invalid-feedback v-bind="context.ariaMsg">
                      {{ context.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="6">
                <validation-provider name="Email" v-slot="context" rules="required|email">
                  <b-form-group label="Email">
                    <b-form-input
                      placeholder="e.g brynhild@gmail.com"
                      v-model="user.email"
                      :state="getValidationState(context)"
                      :disabled="updateIsDisabled"
                      v-bind="context.ariaInput"
                    />

                    <b-form-invalid-feedback v-bind="context.ariaMsg">
                      {{ context.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="6">
                <validation-provider name="Phone Number" v-slot="context">
                  <b-form-group label="Phone Number">
                    <b-form-input
                      v-model="user.phone"
                      :state="getValidationState(context)"
                      :disabled="updateIsDisabled"
                      v-bind="context.ariaInput"
                    />

                    <b-form-invalid-feedback v-bind="context.ariaMsg">
                      {{ context.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="6">
                <validation-provider name="Address" v-slot="context">
                  <b-form-group label="Address">
                    <b-form-textarea
                      v-model="user.address"
                      :state="getValidationState(context)"
                      :disabled="updateIsDisabled"
                      v-bind="context.ariaInput"
                    />

                    <b-form-invalid-feedback v-bind="context.ariaMsg">
                      {{ context.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="3">
                <validation-provider name="Zip" v-slot="context">
                  <b-form-group label="Zip">
                    <b-form-input
                      v-model="user.zip"
                      :state="getValidationState(context)"
                      :disabled="updateIsDisabled"
                      v-bind="context.ariaInput"
                    />

                    <b-form-invalid-feedback v-bind="context.ariaMsg">
                      {{ context.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="3">
                <validation-provider name="City" v-slot="context">
                  <b-form-group label="City">
                    <b-form-input
                      v-model="user.city"
                      :state="getValidationState(context)"
                      :disabled="updateIsDisabled"
                      v-bind="context.ariaInput"
                    />

                    <b-form-invalid-feedback v-bind="context.ariaMsg">
                      {{ context.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>

            <hr />

            <b-row align-h="end">
              <b-col cols="auto">
                <b-button :disabled="updateIsDisabled || invalid" variant="primary" type="submit">
                  Update
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </form>
      </validation-observer>
      <br />
      <validation-observer v-if="profileIsLoggedIn" v-slot="{ invalid }">
        <form @submit.prevent="submitPasswordData">
          <b-card title="Password">
            <b-row>
              <b-col>
                <validation-provider name="Password" v-slot="context" rules="required">
                  <b-form-group label="Password">
                    <b-form-input
                      v-model="password"
                      :state="getValidationState(context)"
                      :disabled="updateIsDisabled"
                      v-bind="context.ariaInput"
                      type="password"
                    />

                    <b-form-invalid-feedback v-bind="context.ariaMsg">
                      {{ context.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col>
                <validation-provider name="Password Confirmation" v-slot="context" rules="required">
                  <b-form-group label="Confirm Password">
                    <b-form-input
                      v-model="password_confirmation"
                      :state="getValidationState(context)"
                      :disabled="updateIsDisabled"
                      v-bind="context.ariaInput"
                      type="password"
                    />

                    <b-form-invalid-feedback v-bind="context.ariaMsg">
                      {{ context.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>

            <hr />

            <b-row align-h="end">
              <b-col cols="auto">
                <b-button :disabled="updateIsDisabled || invalid" variant="primary" type="submit">
                  Update
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </form>
      </validation-observer>
    </b-col>
  </b-row>
</template>

<script>
import { users } from '@youwish1/api-package'
import { mapGetters } from 'vuex'
import { getValidationState } from '../page-helpers'

export default {
  name: 'UserSettings',
  props: { profile: { type: Object } },
  data() {
    return { user: this.profile, password: '', password_confirmation: '' }
  },
  watch: {
    profile(profile) {
      this.user = profile
    },
  },
  computed: {
    ...mapGetters({ loggedInUser: 'auth/user' }),
    profileIsLoggedIn() {
      return true
    },
    userProfileIsAdmin() {
      const roles = ['Super Admin', 'Dashboard User']

      return this.user.roles?.some(role => roles.includes(role))
    },
    updateIsDisabled() {
      return this.userProfileIsAdmin && !this.profileIsLoggedIn
    },
  },
  methods: {
    getValidationState,
    async submitProfileData() {
      await users.update(this.profile.id, {
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        email: this.user.email,
        phone: this.user.phone,
        address: this.user.address,
        zip: this.user.zip,
        city: this.user.city,
      })

      this.$bvToast.toast(`Profile data was successfully updated.`, {
        title: 'Profile updated',
        variant: 'primary',
      })
    },
    async submitPasswordData() {
      await users.update(this.user.id, { password: this.password })
      this.$bvToast.toast(`Password updated.`, {
        title: 'Password updated',
        variant: 'primary',
      })
    },
  },
}
</script>
